import router from '../services/router_service';
import slatepageController from '../controllers/slatepage_controller';

router.on('route:slatepage', slatepageController);
